/**
 * ContentReplyCommentInfo Remapper
 * Flutter source: lib/data/models/content_reply_comment_info.dart
 */

import type { ContentReplyCommentInfoDto } from '@/data/dtos/comment/contentReplyCommentInfoDto';
import type { JsonObject } from '@/data/types/json';
import type { ContentReplyCommentInfoEntity } from '@/domain/entities/comment/contentReplyCommentInfoEntity';

export class ContentReplyCommentInfoRemapper {
  static fromJson(data: JsonObject): ContentReplyCommentInfoDto {
    return {
      commentId: (data['commentId'] as string | undefined) || '',
      replyId: data['replyId'] as string | undefined,
      parentId: data['parentId'] as string | undefined,
      mediaPath: (data['mediaPath'] as string | undefined) || '',
      replyUsername: (data['replyUsername'] as string | undefined) || '',
    };
  }

  static fromJsonList(dataList: JsonObject[]): ContentReplyCommentInfoDto[] {
    return dataList.map(ContentReplyCommentInfoRemapper.fromJson);
  }

  static toEntity(dto: ContentReplyCommentInfoDto): ContentReplyCommentInfoEntity {
    return { ...dto };
  }

  static toDto(entity: ContentReplyCommentInfoEntity): ContentReplyCommentInfoDto {
    return { ...entity };
  }

  /**
   * Emits all five keys unconditionally, with explicit `null` for an absent
   * `replyId` / `parentId`. Mirrors Flutter's generated serializer
   * `_$ContentReplyCommentInfoToJson`
   * (lib/data/models/content_reply_comment_info.g.dart:17-24), which has no
   * `includeIfNull: false` and therefore always writes all five keys. The CF
   * stores this object verbatim on the `processingMedia` doc
   * (cloud_functions/functions/src/functions/transcoding/transcode_user_video.ts:115),
   * so a web-published reply must persist the same key set as a Flutter one.
   */
  static toJson(dto: ContentReplyCommentInfoDto): JsonObject {
    return {
      commentId: dto.commentId,
      replyId: dto.replyId ?? null,
      parentId: dto.parentId ?? null,
      mediaPath: dto.mediaPath,
      replyUsername: dto.replyUsername,
    };
  }
}
